// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  30% {
    transform: rotate(0deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(5deg);
  }
  70% {
    transform: rotate(0deg);
  }
  80% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes sonar {
  0% {
    transform: scale(0.9);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
ion-header {
  position: fixed;
  top: 0;
  box-shadow: none;
  height: 50px;
}

body {
  font-size: 0.9rem;
}

.navbar_header {
  padding-top: 10px;
  color: var(--menu_bar_text_color);
  font-weight: 900;
  font-size: 22px;
  text-align: center;
  background-color: white;
}

.profile_view::after {
  bottom: 0;
  position: fixed !important;
}

.header-md::after {
  bottom: 0;
  position: fixed !important;
}

.sidebar-wrapper .page-wrapper,
.sidebar-wrapper .sidebar-brand > a,
.sidebar-wrapper .sidebar-dropdown > a:after,
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a:before,
.sidebar-wrapper ul li a i,
.sidebar-wrapper .sidebar-search input.search-menu,
.sidebar-wrapper .sidebar-search .input-group-text,
.sidebar-wrapper .sidebar-menu ul li a {
  transition: all 0.3s ease;
}

.page-wrapper .page-content,
#show-sidebar,
#close-sidebar {
  transition: all 0.3s ease;
}

/*----------------page-wrapper----------------*/
.page-wrapper .theme {
  width: 40px;
  height: 40px;
  display: inline-block;
  border-radius: 4px;
  margin: 2px;
}
.page-wrapper .theme.chiller-theme {
  background: aqua;
}

/*----------------toggeled sidebar----------------*/
.page-wrapper.toggled .sidebar-wrapper {
  left: 0px;
  top: 0px;
}

@media screen and (min-width: 768px) {
  .page-wrapper.toggled .page-content {
    padding-left: 300px;
  }
}
/*----------------show sidebar button----------------*/
#show-sidebar {
  left: 10px;
  top: 10px;
  margin-top: 10px;
  border-radius: 0 4px 4px 0px;
  width: 35px;
  transition-delay: 0.3s;
  background: none;
  border: none;
}

.nav-icon {
  color: var(--menu_bar_text_color);
}

/*----------------sidebar-wrapper----------------*/
.sidebar-wrapper {
  width: 260px;
  height: 100%;
  max-height: 100%;
  position: fixed;
  top: 0;
  left: -300px;
  z-index: 999;
}
.sidebar-wrapper ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.sidebar-wrapper a {
  text-decoration: none;
}

/*----------------sidebar-content----------------*/
.sidebar-content {
  max-height: calc(100% - 30px);
  height: calc(100% - 30px);
  overflow-y: auto;
  position: relative;
}
.sidebar-content.desktop {
  overflow-y: hidden;
}

.sidebar-wrapper {
  /*-------sidebar-brand--------*/
  /*-------sidebar-header--------*/
  /*-------sidebar-search--------*/
  /*-------sidebar-menu--------*/
  /*------scroll bar--------*/
}
.sidebar-wrapper .sidebar-brand {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  position: fixed;
}
.sidebar-wrapper .sidebar-brand > a {
  text-transform: uppercase;
  font-weight: bold;
  flex-grow: 1;
}
.sidebar-wrapper .sidebar-brand #close-sidebar {
  cursor: pointer;
  font-size: 20px;
}
.sidebar-wrapper .sidebar-header {
  padding: 20px;
  overflow: hidden;
}
.sidebar-wrapper .sidebar-header .user-pic {
  float: left;
  width: 60px;
  padding: 2px;
  border-radius: 12px;
  margin-right: 15px;
  overflow: hidden;
}
.sidebar-wrapper .sidebar-header .user-pic img {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.sidebar-wrapper .sidebar-header .user-info {
  float: left;
}
.sidebar-wrapper .sidebar-header .user-info > span {
  display: block;
}
.sidebar-wrapper .sidebar-header .user-info .user-role {
  font-size: 12px;
}
.sidebar-wrapper .sidebar-header .user-info .user-status {
  font-size: 11px;
  margin-top: 4px;
}
.sidebar-wrapper .sidebar-header .user-info .user-status i {
  font-size: 8px;
  margin-right: 4px;
  color: #5cb85c;
}
.sidebar-wrapper .sidebar-search > div {
  padding: 10px 20px;
}
.sidebar-wrapper .sidebar-menu {
  cursor: pointer;
  padding-bottom: 70px;
}
.sidebar-wrapper .sidebar-menu .header-menu span {
  font-weight: bold;
  font-size: 14px;
  padding: 15px 20px 5px 20px;
  display: inline-block;
}
.sidebar-wrapper .sidebar-menu ul li a {
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  position: relative;
  padding: 3px 30px 3px 20px;
  display: inline-flex;
}
.sidebar-wrapper .sidebar-menu ul li a i {
  margin-right: 5px;
  font-size: 12px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
}
.sidebar-wrapper .sidebar-menu ul li a i.fa.fa-square {
  width: 20px;
  height: 20px;
  line-height: 15px;
  text-align: start;
  padding-left: 7px;
}
.sidebar-wrapper .sidebar-menu ul li a:hover > i::before {
  display: inline-block;
  animation: swing ease-in-out 0.5s 1 alternate;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown > a:after {
  cursor: pointer;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\\f105";
  font-style: normal;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: 0 0;
  position: absolute;
  right: 15px;
  top: 8px;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu ul {
  cursor: pointer;
  padding: 5px 0;
  list-style-type: none !important;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li {
  padding-left: 10px;
  font-size: 13px;
}
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li .fa-square:before {
  font-size: 5px;
}
.sidebar-wrapper ::-webkit-scrollbar {
  width: 5px;
  height: 7px;
}
.sidebar-wrapper ::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.sidebar-wrapper ::-webkit-scrollbar-thumb {
  background: #525965;
  border: 0px none #ffffff;
  border-radius: 0px;
}
.sidebar-wrapper ::-webkit-scrollbar-thumb:hover, .sidebar-wrapper ::-webkit-scrollbar-thumb:active {
  background: #525965;
}
.sidebar-wrapper ::-webkit-scrollbar-track {
  background: transparent;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.sidebar-wrapper ::-webkit-scrollbar-track:hover, .sidebar-wrapper ::-webkit-scrollbar-track:active {
  background: transparent;
}
.sidebar-wrapper ::-webkit-scrollbar-corner {
  background: transparent;
}

/*----------------------sidebar-menu-------------------------*/
.sidebar-wrapper .sidebar-menu ul li a span.label,
.sidebar-wrapper .sidebar-menu ul li a span.badge {
  float: right;
  margin-top: 8px;
  margin-left: 5px;
}

.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .badge,
.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .label {
  float: right;
  margin-top: 0px;
}

.sidebar-wrapper .sidebar-menu .sidebar-submenu {
  display: none;
}

.sidebar-wrapper .sidebar-menu .sidebar-dropdown.active > a:after {
  transform: rotate(90deg);
  right: 17px;
}

.sidebar-wrapper .sidebar-menu ul {
  padding: 5px 0;
  list-style-type: none;
}

/*-------side-footer-------*/
.sidebar-footer {
  position: absolute;
  width: 100%;
  bottom: 0px;
  display: flex;
}
.sidebar-footer > a {
  flex-grow: 1;
  text-align: center;
  height: 30px;
  line-height: 30px;
  position: relative;
}
.sidebar-footer > a .notification {
  position: absolute;
  top: 0;
}

.badge-sonar {
  display: inline-block;
  background: #980303;
  border-radius: 50%;
  height: 8px;
  width: 8px;
  position: absolute;
  top: 0;
}
.badge-sonar :after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border: 2px solid #980303;
  opacity: 0;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  animation: sonar 1.5s infinite;
}

/*------page-content------*/
.page-wrapper .page-content {
  display: inline-block;
  width: 100%;
  padding-left: 0px;
  padding-top: 20px;
  overflow-x: hidden;
}
.page-wrapper .page-content > div {
  padding: 20px 40px;
}

/*------chiller-theme-------*/
.chiller-theme.page-wrapper.toggled #close-sidebar {
  color: #bdbdbd;
}
.chiller-theme.page-wrapper.toggled #close-sidebar:hover {
  color: #ffffff;
}
.chiller-theme .sidebar-wrapper {
  background: var(--nav_bar_primary_color);
}
.chiller-theme .sidebar-wrapper .sidebar-header,
.chiller-theme .sidebar-wrapper .sidebar-search,
.chiller-theme .sidebar-wrapper .sidebar-menu {
  border-top: 1px solid #3a3f48;
}
.chiller-theme .sidebar-wrapper .sidebar-menu ul li:hover > a,
.chiller-theme .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active > a,
.chiller-theme .sidebar-wrapper .sidebar-header .user-info,
.chiller-theme .sidebar-wrapper .sidebar-brand > a:hover {
  color: var(--nav_bar_hover_color);
  font-weight: bolder;
}
.chiller-theme .sidebar-wrapper ul li ul li:hover a:not(.process) i,
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu:focus + span {
  color: var(--nav_bar_hover_color);
  text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);
}
.chiller-theme .sidebar-wrapper ul li:hover a:not(.process) i,
.chiller-theme .sidebar-wrapper ul li:focus a i .fa-chalkboard {
  color: var(--nav_bar_hover_color);
  text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);
}
.chiller-theme .sidebar-wrapper ul li ul li:not(:hover) a:not(.process) i,
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu:focus + span {
  color: #fff;
  text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);
}
.chiller-theme .sidebar-wrapper .sidebar-menu ul li a i,
.chiller-theme .sidebar-wrapper .sidebar-menu .sidebar-dropdown div {
  background: var(--nav_bar_secondary_color);
}
.chiller-theme .sidebar-wrapper .sidebar-menu .header-menu span {
  color: #fff;
}
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu,
.chiller-theme .sidebar-wrapper .sidebar-search .input-group-text {
  background: #3a3f48;
  border-color: transparent;
  box-shadow: none;
}
.chiller-theme .sidebar-wrapper .sidebar-header .user-info .user-role,
.chiller-theme .sidebar-wrapper .sidebar-header .user-info .user-status,
.chiller-theme .sidebar-wrapper .sidebar-search input.search-menu,
.chiller-theme .sidebar-wrapper .sidebar-search .input-group-text,
.chiller-theme .sidebar-wrapper .sidebar-brand > a,
.chiller-theme .sidebar-wrapper .sidebar-menu ul li a {
  color: #fff;
}
.chiller-theme .sidebar-footer {
  background: #3a3f48;
  box-shadow: 0px -1px 5px #282c33;
  border-top: 1px solid #464a52;
}
.chiller-theme .sidebar-footer > a {
  color: #fff;
}
.chiller-theme .sidebar-footer > a:hover i {
  color: #bdbdbd;
}
.chiller-theme .sidebar-footer > a:first-child {
  border-left: none;
}
.chiller-theme .sidebar-footer > a:last-child {
  border-right: none;
}

.ul-none {
  padding: 5px 0 !important;
  list-style-type: none !important;
  margin-left: 0 !important;
}

/*------ pinned sidebar ------*/
.pin-sidebar {
  cursor: pointer;
  padding: 0 15px;
  color: var(--menu_bar_text_color);
}
.pin-sidebar:hover {
  cursor: pointer;
  color: var(--menu_bar_text_color);
}

@media screen and (max-width: 767.9px) {
  .pin-sidebar {
    cursor: pointer;
    display: none;
  }
}
.close-sidebar {
  float: right;
  margin-top: 5px;
}

.pinned-sidebar {
  /*
  .close-sidebar {
    display: none;
  }
  */
}
.pinned-sidebar.sidebar-wrapper {
  cursor: pointer;
  position: fixed;
}
.pinned-sidebar .pin-sidebar:after {
  cursor: pointer;
  content: "/";
  position: relative;
  color: var(--menu_bar_text_color);
  font-size: 1.6em;
  font-weight: 700;
  transform: rotate(10deg);
}

.HideUser {
  background-color: white;
  color: var(--menu_bar_text_color);
  padding: 10px;
  border-radius: 3px;
}

.user-name {
  font-size: larger;
  font-weight: bolder;
  min-width: 100px; /* Adjust the minimum width as needed */
  max-width: 200px; /* Adjust the maximum width as needed */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.routeColor {
  color: var(--nav_bar_selected_menu_color);
  font-weight: bold;
}

.routeColor:after {
  color: var(--nav_bar_selected_menu_color);
}

.routeColor:before {
  color: var(--nav_bar_selected_menu_color);
}

headerstyle {
  text-align: center;
}

.nav_loader_body {
  position: fixed;
  display: flex;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  background: var(--menu_bar_loader_back_color);
}

.loading {
  display: flex;
}
.loading .dot {
  position: relative;
  width: 2em;
  height: 2em;
  margin: 0.8em;
  border-radius: 50%;
}
.loading .dot::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: inherit;
  border-radius: inherit;
  animation: wave 2s ease-out infinite;
}
.loading .dot:nth-child(1) {
  background: var(--menu_bar_1_loader_color);
}
.loading .dot:nth-child(1)::before {
  animation-delay: 0.2s;
}
.loading .dot:nth-child(2) {
  background: var(--menu_bar_2_loader_color);
}
.loading .dot:nth-child(2)::before {
  animation-delay: 0.4s;
}
.loading .dot:nth-child(3) {
  background: var(--menu_bar_3_loader_color);
}
.loading .dot:nth-child(3)::before {
  animation-delay: 0.6s;
}
.loading .dot:nth-child(4) {
  background: var(--menu_bar_4_loader_color);
}
.loading .dot:nth-child(4)::before {
  animation-delay: 0.8s;
}
.loading .dot:nth-child(5) {
  background: var(--menu_bar_5_loader_color);
}
.loading .dot:nth-child(5)::before {
  animation-delay: 1s;
}

span {
  margin-top: auto;
  margin-bottom: auto;
}

@keyframes wave {
  50%, 75% {
    transform: scale(2.5);
  }
  80%, 100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/navbar/navbar.component.scss"],"names":[],"mappings":"AAMA;EACE;IACE,uBAAA;EALF;EAQA;IACE,wBAAA;EANF;EASA;IACE,uBAAA;EAPF;EAUA;IACE,yBAAA;EARF;EAWA;IACE,uBAAA;EATF;EAYA;IACE,uBAAA;EAVF;EAaA;IACE,uBAAA;EAXF;EAcA;IACE,wBAAA;EAZF;EAeA;IACE,uBAAA;EAbF;AACF;AAgBA;EACE;IACE,qBAAA;IACA,UAAA;EAdF;EAiBA;IACE,mBAAA;IACA,UAAA;EAfF;AACF;AAkBA;EACE,eAAA;EACA,MAAA;EACA,gBAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,iBAAA;AAhBF;;AAmBA;EACE,iBAAA;EAEA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAjBF;;AAqBA;EACE,SAAA;EACA,0BAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,0BAAA;AAlBF;;AAuBE;;;;;;;;EAYE,yBAAA;AApBJ;;AAwBA;;;EAOE,yBAAA;AArBF;;AAwBA,+CAAA;AAKE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AAzBJ;AA2BI;EAEE,gBAAA;AA1BN;;AAgCA,mDAAA;AAEA;EACE,SAAA;EACA,QAAA;AA9BF;;AAiCA;EACE;IACE,mBAAA;EA9BF;AACF;AAiCA,sDAAA;AACA;EAEE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAhCF;;AAmCA;EAGE,iCAAA;AAlCF;;AAyCA,kDAAA;AAEA;EACE,YA7Kc;EA8Kd,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;AAvCF;AAyCE;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AAvCJ;AA0CE;EACE,qBAAA;AAxCJ;;AA4CA,kDAAA;AAEA;EACE,6BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AA1CF;AA4CE;EACE,kBAAA;AA1CJ;;AAgDA;EAEE,+BAAA;EAmBA,gCAAA;EA4CA,gCAAA;EAKA,8BAAA;EAmHA,2BAAA;AAjOF;AA2CE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzCJ;AA2CI;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;AAzCN;AA4CI;EACE,eAAA;EACA,eAAA;AA1CN;AA+CE;EACE,aAAA;EACA,gBAAA;AA7CJ;AA+CI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA7CN;AA+CM;EACE,iBAAA;EACA,YAAA;EACA,WAAA;AA7CR;AAiDI;EACE,WAAA;AA/CN;AAiDM;EACE,cAAA;AA/CR;AAkDM;EACE,eAAA;AAhDR;AAmDM;EACE,eAAA;EACA,eAAA;AAjDR;AAmDQ;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AAjDV;AAwDE;EACE,kBAAA;AAtDJ;AA0DE;EACE,eAAA;EACA,oBAAA;AAxDJ;AA2DI;EACE,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,qBAAA;AAzDN;AA4DI;EACE,eAAA;EAEA,WAAA;EACA,qBAAA;EACA,kBAAA;EAEA,0BAAA;EACA,oBAAA;AA5DN;AAkEM;EAEE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAjER;AAoEM;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAnER;AAsEM;EACE,qBAAA;EACA,6CAAA;AApER;AAyEM;EACE,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EAEA,QAAA;AAxER;AA4EQ;EACE,eAAA;EACA,cAAA;EACA,gCAAA;AA1EV;AA6EQ;EAEE,kBAAA;EACA,eAAA;AA5EV;AA8EU;EACE,cAAA;AA5EZ;AA0GE;EACE,UAAA;EACA,WAAA;AAxGJ;AA2GE;EACE,UAAA;EACA,WAAA;AAzGJ;AA4GE;EACE,mBAAA;EAEA,wBAAA;EACA,kBAAA;AA3GJ;AA6GI;EAEE,mBAAA;AA5GN;AAgHE;EACE,uBAAA;EACA,wBAAA;EACA,mBAAA;AA9GJ;AAgHI;EAEE,uBAAA;AA/GN;AAmHE;EACE,uBAAA;AAjHJ;;AAsHA,8DAAA;AAGA;;EAEE,YAAA;EACA,eAAA;EACA,gBAAA;AArHF;;AAwHA;;EAEE,YAAA;EACA,eAAA;AArHF;;AAwHA;EACE,aAAA;AArHF;;AAwHA;EACE,wBAAA;EACA,WAAA;AArHF;;AAwHA;EACE,cAAA;EACA,qBAAA;AArHF;;AAoIA,4BAAA;AAEA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;AAlIF;AAoIE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAlIJ;AAoII;EACE,kBAAA;EACA,MAAA;AAlIN;;AAyIA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;AAtIF;AAwIE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;AAtIJ;;AA0IA,2BAAA;AAEA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAxIF;AA0IE;EACE,kBAAA;AAxIJ;;AA4IA,6BAAA;AAGE;EACE,cAAA;AA3IJ;AA6II;EACE,cAAA;AA3IN;AA+IE;EAGE,wCAAA;AA/IJ;AAkJE;;;EAGE,6BAAA;AAhJJ;AAqJE;;;;EAIE,iCAAA;EACA,mBAAA;AAnJJ;AAmKE;;EAGE,iCAAA;EACA,iDAAA;AAlKJ;AAsKE;;EAKE,iCAAA;EACA,iDAAA;AAvKJ;AA0KE;;EAEE,WAAA;EACA,iDAAA;AAxKJ;AAmLI;;EAGE,0CAAA;AAlLN;AAsLI;EACE,WAAA;AApLN;AAwLE;;EAEE,mBAAA;EACA,yBAAA;EACA,gBAAA;AAtLJ;AAyLE;;;;;;EAOE,WAAA;AAxLJ;AA2LE;EACE,mBAAA;EACA,gCAAA;EACA,6BAAA;AAzLJ;AA2LI;EAEE,WAAA;AA1LN;AA6LI;EACE,cAAA;AA3LN;AA8LI;EACE,iBAAA;AA5LN;AA+LI;EACE,kBAAA;AA7LN;;AAkMA;EACE,yBAAA;EACA,gCAAA;EACA,yBAAA;AA/LF;;AAkMA,+BAAA;AAEA;EACE,eAAA;EACA,eAAA;EAEA,iCAAA;AAjMF;AAmME;EACE,eAAA;EAEA,iCAAA;AAlMJ;;AAsMA;EACE;IACE,eAAA;IACA,aAAA;EAnMF;AACF;AAsMA;EAEE,YAAA;EACA,eAAA;AArMF;;AAwMA;EAME;;;;GAAA;AAtMF;AAiME;EACE,eAAA;EACA,eAAA;AA/LJ;AAyMI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EAEA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;AAxMN;;AAgNA;EACE,uBAAA;EAGA,iCAAA;EAGA,aAAA;EAEA,kBAAA;AAlNF;;AAqNA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA,EAAA,uCAAA;EACA,gBAAA,EAAA,uCAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAlNF;;AAqNA;EAEE,yCAAA;EAEA,iBAAA;AApNF;;AAsNA;EAEE,yCAAA;AApNF;;AAuNA;EAEE,yCAAA;AArNF;;AAwNA;EACE,kBAAA;AArNF;;AA0NA;EACE,eAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;AAvNF;;AA0NA;EAEE,aAAA;AAxNF;AA0NE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAxNJ;AA0NI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;AAxNN;AA4NM;EACE,0CAAA;AA1NR;AA4NQ;EACE,qBAAA;AA1NV;AAsNM;EACE,0CAAA;AApNR;AAsNQ;EACE,qBAAA;AApNV;AAgNM;EACE,0CAAA;AA9MR;AAgNQ;EACE,qBAAA;AA9MV;AA0MM;EACE,0CAAA;AAxMR;AA0MQ;EACE,qBAAA;AAxMV;AAoMM;EACE,0CAAA;AAlMR;AAoMQ;EACE,mBAAA;AAlMV;;AAyMA;EAEE,gBAAA;EACA,mBAAA;AAvMF;;AA0MA;EACE;IAEE,qBAAA;EAxMF;EA2MA;IAEE,UAAA;EA1MF;AACF","sourcesContent":["\r\n\r\n$sidebarWidth : 260px;\r\n\r\n\r\n\r\n@keyframes swing {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  10% {\r\n    transform: rotate(10deg);\r\n  }\r\n\r\n  30% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  40% {\r\n    transform: rotate(-10deg);\r\n  }\r\n\r\n  50% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  60% {\r\n    transform: rotate(5deg);\r\n  }\r\n\r\n  70% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  80% {\r\n    transform: rotate(-5deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(0deg);\r\n  }\r\n}\r\n\r\n@keyframes sonar {\r\n  0% {\r\n    transform: scale(0.9);\r\n    opacity: 1;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(2);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\nion-header {\r\n  position: fixed;\r\n  top: 0;\r\n  box-shadow: none;\r\n  height: 50px;;\r\n}\r\n\r\nbody {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.navbar_header {\r\n  padding-top: 10px;\r\n  // color: #6C0BA9;\r\n  color: var(--menu_bar_text_color);\r\n  font-weight: 900;\r\n  font-size: 22px;\r\n  text-align: center;\r\n  background-color: white;\r\n}\r\n\r\n\r\n.profile_view::after {\r\n  bottom: 0;\r\n  position: fixed !important;\r\n}\r\n\r\n.header-md::after {\r\n  bottom: 0;\r\n  position: fixed !important;\r\n}\r\n\r\n.sidebar-wrapper {\r\n\r\n  .page-wrapper,\r\n  .sidebar-brand>a,\r\n  .sidebar-dropdown>a:after,\r\n  .sidebar-menu .sidebar-dropdown .sidebar-submenu li a:before,\r\n  ul li a i,\r\n  .sidebar-search input.search-menu,\r\n  .sidebar-search .input-group-text,\r\n  .sidebar-menu ul li a {\r\n    -webkit-transition: all 0.3s ease;\r\n    -moz-transition: all 0.3s ease;\r\n    -ms-transition: all 0.3s ease;\r\n    -o-transition: all 0.3s ease;\r\n    transition: all 0.3s ease;\r\n  }\r\n}\r\n\r\n.page-wrapper .page-content,\r\n#show-sidebar,\r\n#close-sidebar {\r\n  -webkit-transition: all 0.3s ease;\r\n  -moz-transition: all 0.3s ease;\r\n  -ms-transition: all 0.3s ease;\r\n  -o-transition: all 0.3s ease;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/*----------------page-wrapper----------------*/\r\n\r\n.page-wrapper {\r\n  // height: 100vh;\r\n\r\n  .theme {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: inline-block;\r\n    border-radius: 4px;\r\n    margin: 2px;\r\n\r\n    &.chiller-theme {\r\n      // background: #1e2229;\r\n      background: aqua;\r\n      // background: transparent !important;\r\n    }\r\n  }\r\n}\r\n\r\n/*----------------toggeled sidebar----------------*/\r\n\r\n.page-wrapper.toggled .sidebar-wrapper {\r\n  left: 0px;\r\n  top: 0px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .page-wrapper.toggled .page-content {\r\n    padding-left: 300px;\r\n  }\r\n}\r\n\r\n/*----------------show sidebar button----------------*/\r\n#show-sidebar {\r\n  // position: fixed;\r\n  left: 10px;\r\n  top: 10px;\r\n  margin-top: 10px;\r\n  border-radius: 0 4px 4px 0px;\r\n  width: 35px;\r\n  transition-delay: 0.3s;\r\n  background: none;\r\n  border: none;\r\n}\r\n\r\n.nav-icon {\r\n\r\n  // color: #6C0BA9;\r\n  color: var(--menu_bar_text_color);\r\n}\r\n\r\n// .page-wrapper.toggled #show-sidebar {\r\n//   // left: -40px;\r\n// }\r\n\r\n/*----------------sidebar-wrapper----------------*/\r\n\r\n.sidebar-wrapper {\r\n  width: $sidebarWidth;\r\n  height: 100%;\r\n  max-height: 100%;\r\n  position: fixed;\r\n  top: 0;\r\n  left: -300px;\r\n  z-index: 999;\r\n\r\n  ul {\r\n    list-style-type: none;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n\r\n  a {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n/*----------------sidebar-content----------------*/\r\n\r\n.sidebar-content {\r\n  max-height: calc(100% - 30px);\r\n  height: calc(100% - 30px);\r\n  overflow-y: auto;\r\n  position: relative;\r\n\r\n  &.desktop {\r\n    overflow-y: hidden;\r\n  }\r\n}\r\n\r\n\r\n\r\n.sidebar-wrapper {\r\n\r\n  /*-------sidebar-brand--------*/\r\n  .sidebar-brand {\r\n    padding: 10px 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    position: fixed;\r\n\r\n    >a {\r\n      text-transform: uppercase;\r\n      font-weight: bold;\r\n      flex-grow: 1;\r\n    }\r\n\r\n    #close-sidebar {\r\n      cursor: pointer;\r\n      font-size: 20px;\r\n    }\r\n  }\r\n\r\n  /*-------sidebar-header--------*/\r\n  .sidebar-header {\r\n    padding: 20px;\r\n    overflow: hidden;\r\n\r\n    .user-pic {\r\n      float: left;\r\n      width: 60px;\r\n      padding: 2px;\r\n      border-radius: 12px;\r\n      margin-right: 15px;\r\n      overflow: hidden;\r\n\r\n      img {\r\n        object-fit: cover;\r\n        height: 100%;\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .user-info {\r\n      float: left;\r\n\r\n      >span {\r\n        display: block;\r\n      }\r\n\r\n      .user-role {\r\n        font-size: 12px;\r\n      }\r\n\r\n      .user-status {\r\n        font-size: 11px;\r\n        margin-top: 4px;\r\n\r\n        i {\r\n          font-size: 8px;\r\n          margin-right: 4px;\r\n          color: #5cb85c;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /*-------sidebar-search--------*/\r\n  .sidebar-search>div {\r\n    padding: 10px 20px;\r\n  }\r\n\r\n  /*-------sidebar-menu--------*/\r\n  .sidebar-menu {\r\n    cursor: pointer;\r\n    padding-bottom: 70px;\r\n    // margin-top: 20%;\r\n\r\n    .header-menu span {\r\n      font-weight: bold;\r\n      font-size: 14px;\r\n      padding: 15px 20px 5px 20px;\r\n      display: inline-block;\r\n    }\r\n\r\n    ul li a {\r\n      cursor: pointer;\r\n      // display: inline-block;\r\n      width: 100%;\r\n      text-decoration: none;\r\n      position: relative;\r\n      // padding: 8px 30px 8px 20px;\r\n      padding: 3px 30px 3px 20px;\r\n      display: inline-flex;\r\n\r\n      // &.process {\r\n      //   padding-left: 60px;\r\n      // }\r\n\r\n      i {\r\n        // margin-right: 10px;\r\n        margin-right: 5px;\r\n        font-size: 12px;\r\n        width: 30px;\r\n        height: 30px;\r\n        line-height: 30px;\r\n        text-align: center;\r\n        border-radius: 4px;\r\n      }\r\n\r\n      i.fa.fa-square\r\n      {\r\n        width: 20px;\r\n        height: 20px;\r\n        line-height: 15px;\r\n        text-align: start;\r\n        padding-left: 7px;\r\n      }\r\n\r\n      &:hover>i::before {\r\n        display: inline-block;\r\n        animation: swing ease-in-out 0.5s 1 alternate;\r\n      }\r\n    }\r\n\r\n    .sidebar-dropdown {\r\n      >a:after {\r\n        cursor: pointer;\r\n        font-family: \"Font Awesome 5 Free\";\r\n        font-weight: 900;\r\n        content: \"\\f105\";\r\n        font-style: normal;\r\n        display: inline-block;\r\n        font-style: normal;\r\n        font-variant: normal;\r\n        text-rendering: auto;\r\n        -webkit-font-smoothing: antialiased;\r\n        -moz-osx-font-smoothing: grayscale;\r\n        text-align: center;\r\n        background: 0 0;\r\n        position: absolute;\r\n        right: 15px;\r\n        // top: 14px;\r\n        top: 8px;\r\n      }\r\n\r\n      .sidebar-submenu {\r\n        ul {\r\n          cursor: pointer;\r\n          padding: 5px 0;\r\n          list-style-type: none !important;\r\n        }\r\n\r\n        li {\r\n          // padding-left: 25px;\r\n          padding-left: 10px;\r\n          font-size: 13px;\r\n\r\n          .fa-square:before {\r\n            font-size: 5px;\r\n            // position: absolute;\r\n            // top: 20px;\r\n          }\r\n\r\n          // .process:before {\r\n          //   content: \"\\f0c8\";\r\n          //   font-family: \"Font Awesome 5 Free\";\r\n          //   font-weight: 400;\r\n          //   font-style: normal;\r\n          //   // display: inline-block;\r\n          //   text-decoration: none;\r\n          //   -webkit-font-smoothing: antialiased;\r\n          //   -moz-osx-font-smoothing: grayscale;\r\n          //   margin-right: 5px;\r\n          //   font-size: 5px;\r\n          //   background-color: white;\r\n          //   margin-top: 100%;\r\n          //   position: absolute;\r\n          //   left: 35px;\r\n          //   bottom: 12px;\r\n          // }\r\n        }\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  /*------scroll bar--------*/\r\n\r\n  ::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 7px;\r\n  }\r\n\r\n  ::-webkit-scrollbar-button {\r\n    width: 0px;\r\n    height: 0px;\r\n  }\r\n\r\n  ::-webkit-scrollbar-thumb {\r\n    background: #525965;\r\n    // background: #000;\r\n    border: 0px none #ffffff;\r\n    border-radius: 0px;\r\n\r\n    &:hover,\r\n    &:active {\r\n      background: #525965;\r\n    }\r\n  }\r\n\r\n  ::-webkit-scrollbar-track {\r\n    background: transparent;\r\n    border: 0px none #ffffff;\r\n    border-radius: 50px;\r\n\r\n    &:hover,\r\n    &:active {\r\n      background: transparent;\r\n    }\r\n  }\r\n\r\n  ::-webkit-scrollbar-corner {\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n\r\n/*----------------------sidebar-menu-------------------------*/\r\n\r\n\r\n.sidebar-wrapper .sidebar-menu ul li a span.label,\r\n.sidebar-wrapper .sidebar-menu ul li a span.badge {\r\n  float: right;\r\n  margin-top: 8px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .badge,\r\n.sidebar-wrapper .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .label {\r\n  float: right;\r\n  margin-top: 0px;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu .sidebar-submenu {\r\n  display: none;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a:after {\r\n  transform: rotate(90deg);\r\n  right: 17px;\r\n}\r\n\r\n.sidebar-wrapper .sidebar-menu ul {\r\n  padding: 5px 0;\r\n  list-style-type: none;\r\n}\r\n\r\n// .sidebar-wrapper .sidebar-menu ul {\r\n//   padding: 5px 0;\r\n//   list-style-type: none !important;\r\n// }\r\n\r\n// .sidebar-wrapper .sidebar-menu ul {\r\n//   padding: 5px 0 !important;\r\n//   list-style-type: none !important;\r\n//   margin-left: 0 !important;\r\n// }\r\n\r\n\r\n/*-------side-footer-------*/\r\n\r\n.sidebar-footer {\r\n  position: absolute;\r\n  width: 100%;\r\n  bottom: 0px;\r\n  display: flex;\r\n\r\n  >a {\r\n    flex-grow: 1;\r\n    text-align: center;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    position: relative;\r\n\r\n    .notification {\r\n      position: absolute;\r\n      top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.badge-sonar {\r\n  display: inline-block;\r\n  background: #980303;\r\n  border-radius: 50%;\r\n  height: 8px;\r\n  width: 8px;\r\n  position: absolute;\r\n  top: 0;\r\n\r\n  :after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    border: 2px solid #980303;\r\n    opacity: 0;\r\n    border-radius: 50%;\r\n    width: 100%;\r\n    height: 100%;\r\n    animation: sonar 1.5s infinite;\r\n  }\r\n}\r\n\r\n/*------page-content------*/\r\n\r\n.page-wrapper .page-content {\r\n  display: inline-block;\r\n  width: 100%;\r\n  padding-left: 0px;\r\n  padding-top: 20px;\r\n  overflow-x: hidden;\r\n\r\n  >div {\r\n    padding: 20px 40px;\r\n  }\r\n}\r\n\r\n/*------chiller-theme-------*/\r\n\r\n.chiller-theme {\r\n  &.page-wrapper.toggled #close-sidebar {\r\n    color: #bdbdbd;\r\n\r\n    &:hover {\r\n      color: #ffffff;\r\n    }\r\n  }\r\n\r\n  .sidebar-wrapper {\r\n    // background: #31353D;\r\n    // background: #51087E;\r\n    background: var(--nav_bar_primary_color);\r\n  }\r\n\r\n  .sidebar-wrapper .sidebar-header,\r\n  .sidebar-wrapper .sidebar-search,\r\n  .sidebar-wrapper .sidebar-menu {\r\n    border-top: 1px solid #3a3f48;\r\n  }\r\n\r\n  \r\n\r\n  .sidebar-wrapper .sidebar-menu  ul li:hover>a,\r\n  .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active>a,\r\n  .sidebar-wrapper .sidebar-header .user-info,\r\n  .sidebar-wrapper .sidebar-brand>a:hover {\r\n    color: var(--nav_bar_hover_color);\r\n    font-weight: bolder;\r\n    // color: gold;\r\n  }\r\n\r\n\r\n  \r\n  // .sidebar-wrapper ul li:hover a:not(.process) i,  \r\n  // // .sidebar-wrapper .sidebar-dropdown .sidebar-submenu li a:not(.process):hover:before,\r\n  // .sidebar-wrapper .sidebar-search input.search-menu:focus+span //, .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active a i \r\n\r\n  //   {\r\n  //   // color: #16c7ff;\r\n  //   color: #c26df7;\r\n  //   text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  // }\r\n\r\n  .sidebar-wrapper ul li ul li:hover a:not(.process) i,\r\n  .sidebar-wrapper .sidebar-search input.search-menu:focus+span {\r\n    // color: #c26df7;\r\n    color: var(--nav_bar_hover_color);\r\n    text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  }\r\n\r\n\r\n  .sidebar-wrapper ul li:hover a:not(.process) i,\r\n  .sidebar-wrapper ul li:focus a i .fa-chalkboard //, .sidebar-wrapper .sidebar-menu .sidebar-dropdown.active a i \r\n\r\n    {\r\n    // color: #c26df7;\r\n    color: var(--nav_bar_hover_color);\r\n    text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  }\r\n\r\n  .sidebar-wrapper ul li ul li:not(:hover) a:not(.process) i,\r\n  .sidebar-wrapper .sidebar-search input.search-menu:focus+span {\r\n    color: #fff;\r\n    text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  }\r\n\r\n\r\n  // .sidebar-wrapper ul li:hover a.process {\r\n  //   color: white;\r\n  //   text-shadow: 0px 0px 10px rgba(22, 199, 255, 0.5);\r\n  // }\r\n\r\n  .sidebar-wrapper .sidebar-menu {\r\n\r\n    ul li a i,\r\n    .sidebar-dropdown div {\r\n      // background: #3a3f48;\r\n      background: var(--nav_bar_secondary_color);\r\n\r\n    }\r\n\r\n    .header-menu span {\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  .sidebar-wrapper .sidebar-search input.search-menu,\r\n  .sidebar-wrapper .sidebar-search .input-group-text {\r\n    background: #3a3f48;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n  }\r\n\r\n  .sidebar-wrapper .sidebar-header .user-info .user-role,\r\n  .sidebar-wrapper .sidebar-header .user-info .user-status,\r\n  .sidebar-wrapper .sidebar-search input.search-menu,\r\n  .sidebar-wrapper .sidebar-search .input-group-text,\r\n  .sidebar-wrapper .sidebar-brand>a,\r\n  .sidebar-wrapper .sidebar-menu ul li a {\r\n    // color: #818896;\r\n    color: #fff;\r\n  }\r\n\r\n  .sidebar-footer {\r\n    background: #3a3f48;\r\n    box-shadow: 0px -1px 5px #282c33;\r\n    border-top: 1px solid #464a52;\r\n\r\n    >a {\r\n      // color: #818896;\r\n      color: #fff;\r\n    }\r\n\r\n    >a:hover i {\r\n      color: #bdbdbd;\r\n    }\r\n\r\n    >a:first-child {\r\n      border-left: none;\r\n    }\r\n\r\n    >a:last-child {\r\n      border-right: none;\r\n    }\r\n  }\r\n}\r\n\r\n.ul-none {\r\n  padding: 5px 0 !important;\r\n  list-style-type: none !important;\r\n  margin-left: 0 !important;\r\n}\r\n\r\n/*------ pinned sidebar ------*/\r\n\r\n.pin-sidebar {\r\n  cursor: pointer;\r\n  padding: 0 15px;\r\n  // color:  #6c0ba9;\r\n  color: var(--menu_bar_text_color);\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n    // color: #7a2aac;\r\n    color: var(--menu_bar_text_color);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767.9px) {\r\n  .pin-sidebar {\r\n    cursor: pointer;\r\n    display: none;\r\n  }\r\n}\r\n\r\n.close-sidebar {\r\n  \r\n  float: right;\r\n  margin-top: 5px;\r\n}\r\n\r\n.pinned-sidebar {\r\n  &.sidebar-wrapper {\r\n    cursor: pointer;\r\n    position: fixed;\r\n  }\r\n\r\n  /*\r\n  .close-sidebar {\r\n    display: none;\r\n  }\r\n  */\r\n\r\n  .pin-sidebar {\r\n    &:after {\r\n      cursor: pointer;\r\n      content: \"/\";\r\n      position: relative;\r\n      // color: #6c0ba9;\r\n      color: var(--menu_bar_text_color);\r\n      font-size: 1.6em;\r\n      font-weight: 700;\r\n      transform: rotate(10deg);\r\n    }\r\n\r\n  }\r\n\r\n}\r\n\r\n\r\n.HideUser {\r\n  background-color: white;\r\n  // background-size: 500px;\r\n  // color: #6C0BA9;\r\n  color: var(--menu_bar_text_color);\r\n  // min-width: 165px;\r\n  // max-width: 300px;\r\n  padding: 10px;\r\n  // font-size: large;\r\n  border-radius: 3px;\r\n}\r\n\r\n.user-name {\r\n  font-size: larger;\r\n  font-weight: bolder;\r\n  min-width: 100px; /* Adjust the minimum width as needed */\r\n  max-width: 200px; /* Adjust the maximum width as needed */\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.routeColor{\r\n  // color:#c26df7;\r\n  color: var(--nav_bar_selected_menu_color);\r\n  // font-size: large;\r\n  font-weight: bold;\r\n}\r\n.routeColor:after{\r\n  // color:#c26df7;\r\n  color: var(--nav_bar_selected_menu_color);\r\n  \r\n}\r\n.routeColor:before{\r\n  // color:#c26df7;\r\n  color: var(--nav_bar_selected_menu_color);\r\n}\r\n\r\nheaderstyle{\r\n  text-align: center;\r\n}\r\n\r\n//  loader css\r\n\r\n.nav_loader_body {\r\n  position: fixed;\r\n  display: flex;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background:  var(--menu_bar_loader_back_color);\r\n}\r\n\r\n.loading {\r\n  $colors: var(--menu_bar_1_loader_color), var(--menu_bar_2_loader_color), var(--menu_bar_3_loader_color), var(--menu_bar_4_loader_color), var(--menu_bar_5_loader_color);\r\n  display: flex;\r\n\r\n  .dot {\r\n    position: relative;\r\n    width: 2em;\r\n    height: 2em;\r\n    margin: 0.8em;\r\n    border-radius: 50%;\r\n\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      width: 100%;\r\n      height: 100%;\r\n      background: inherit;\r\n      border-radius: inherit;\r\n      animation: wave 2s ease-out infinite;\r\n    }\r\n\r\n    @for $i from 1 through 5 {\r\n      &:nth-child(#{$i}) {\r\n        background: nth($colors, $i);\r\n\r\n        &::before {\r\n          animation-delay: $i * 0.2s;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nspan\r\n{\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n\r\n@keyframes wave {\r\n  50%,\r\n  75% {\r\n    transform: scale(2.5);\r\n  }\r\n\r\n  80%,\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
